import { useQuery } from "@apollo/client";
import { getEventHosts, getEventLocations, getPublishedEvents } from "../pages/musicFestival/gql/queries" // Ensure the path is correct
import { Gig, Venue } from "../types/MusicFestivalTypes";

export const useMusicFestivalGigs = () => {
  const { data, loading, error } = useQuery<any>(getPublishedEvents, {
    fetchPolicy: "cache-and-network",
    variables: { eventType: "MusicFestival" },
  });

  return { data, loading, error };
};

export const useMusicFestivalArtists = () => {
  const { data, loading, error } = useQuery<any>(getEventHosts, {
    fetchPolicy: "cache-and-network",
    variables: { eventType: "MusicFestival" },
  });

  return { data, loading, error };
};

export const useMusicFestivalVenues = () => {
  const { data, loading, error } = useQuery<any>(getEventLocations, {
    fetchPolicy: "cache-and-network",
    variables: { eventType: "MusicFestival" },
  });

  return { data, loading, error };
};


export const getMockMusicFestVenues: Venue[] = [
  {
    "description": "45-47 China Street, Lancaster, LA1 1EX",
    "id": "60e48368a0e01a001f4773ab",
    "imageUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/613cb55bb30734001ec7a057/original/pub.jpg",
    "latitude": 54.048958,
    "locationNotes": [],
    "longitude": -2.803113,
    "owner": "MusicFestival",
    "thumbUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/613cb55bb30734001ec7a057/thumb/pub.jpg",
    "title": "The Pub"
  },
  {
    "description": "Priory Close, Lancaster, LA1 1YZ",
    "id": "60e487a475e0fd001ffe28c7",
    "imageUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/611c23af35fe83001eea3bd9/original/lancasterpriory3.jpg",
    "latitude": 54.050591,
    "locationNotes": [],
    "longitude": -2.805768,
    "owner": "MusicFestival",
    "thumbUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/611c23af35fe83001eea3bd9/thumb/lancasterpriory3.jpg",
    "title": "Lancaster Priory"
  },
  {
    "description": "Castle Grove, Lancaster, LA1 1YJ",
    "id": "60e4894275e0fd001ffe2a95",
    "imageUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/611c0e4135fe83001eea3224/original/lancastercastle.jpg",
    "latitude": 54.049526,
    "locationNotes": [],
    "longitude": -2.804843,
    "owner": "MusicFestival",
    "thumbUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/611c0e4135fe83001eea3224/thumb/lancastercastle.jpg",
    "title": "Lancaster Castle"
  },
  {
    "description": "Market Street, Lancaster, LA1 1HT",
    "id": "60e48c6c60c142001eb6ddb3",
    "imageUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/613cb406b30734001ec79fbc/original/marketsquare.jpg",
    "latitude": 54.048825,
    "locationNotes": [],
    "longitude": -2.801197,
    "owner": "MusicFestival",
    "thumbUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/613cb406b30734001ec79fbc/thumb/marketsquare.jpg",
    "title": "Market Square"
  }
]

export const getMockMusicFestGigs: Gig[] = [
  {
    "dayOfTheWeek": "Thursday",
    "endDateUTC": "2024-10-10T00:00:00",
    "endTime": "16:00",
    "eventCategory": "Live Music",
    "eventDescription": "Acoustic",
    "eventName": "Sam Frank",
    "eventType": "MusicFestival",
    "id": "1804",
    "imageUrl": null,
    "locations": [
      {
        "description": "45-47 China Street, Lancaster, LA1 1EX",
        "id": "60e48368a0e01a001f4773ab",
        "imageUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/613cb55bb30734001ec7a057/original/pub.jpg",
        "latitude": 54.048958,
        "locationNotes": [],
        "longitude": -2.803113,
        "owner": "MusicFestival",
        "thumbUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/613cb55bb30734001ec7a057/thumb/pub.jpg",
        "title": "The Pub"
      }
    ],
    "hosts": [],
    "startDateUTC": "2024-10-10T00:00:00",
    "startTime": "15:00",
    "tags": [],
    "videoUrl": null,
    "participantCount": 0
  },
  {
    "dayOfTheWeek": "Thursday",
    "endDateUTC": "2024-10-10T00:00:00",
    "endTime": "17:30",
    "eventCategory": "Live Music",
    "eventDescription": "Acoustic",
    "eventName": "Tom Woods",
    "eventType": "MusicFestival",
    "id": "1805",
    "imageUrl": null,
    "locations": [
      {
        "description": "Priory Close, Lancaster, LA1 1YZ",
        "id": "60e487a475e0fd001ffe28c7",
        "imageUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/611c23af35fe83001eea3bd9/original/lancasterpriory3.jpg",
        "latitude": 54.050591,
        "locationNotes": [],
        "longitude": -2.805768,
        "owner": "MusicFestival",
        "thumbUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/611c23af35fe83001eea3bd9/thumb/lancasterpriory3.jpg",
        "title": "Lancaster Priory"
      }
    ],
    "hosts": [],
    "startDateUTC": "2024-10-10T00:00:00",
    "startTime": "16:00",
    "tags": [],
    "videoUrl": null,
    "participantCount": 0
  },
  {
    "dayOfTheWeek": "Thursday",
    "endDateUTC": "2024-10-10T00:00:00",
    "endTime": "18:30",
    "eventCategory": "Live Music",
    "eventDescription": "Lively covers from a variety of eras",
    "eventName": "Chris Barlow",
    "eventType": "MusicFestival",
    "id": "1806",
    "imageUrl": null,
    "locations": [
      {
        "description": "Castle Grove, Lancaster, LA1 1YJ",
        "id": "60e4894275e0fd001ffe2a95",
        "imageUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/611c0e4135fe83001eea3224/original/lancastercastle.jpg",
        "latitude": 54.049526,
        "locationNotes": [],
        "longitude": -2.804843,
        "owner": "MusicFestival",
        "thumbUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/611c0e4135fe83001eea3224/thumb/lancastercastle.jpg",
        "title": "Lancaster Castle"
      }
    ],
    "hosts": [],
    "startDateUTC": "2024-10-10T00:00:00",
    "startTime": "17:00",
    "tags": [],
    "videoUrl": null,
    "participantCount": 0
  },
  {
    "dayOfTheWeek": "Thursday",
    "endDateUTC": "2024-10-10T00:00:00",
    "endTime": "22:00",
    "eventCategory": "Dance Workshop",
    "eventDescription": "Vintage Dance Hall",
    "eventName": "Lancaster Lindy Circle",
    "eventType": "MusicFestival",
    "id": "1807",
    "imageUrl": null,
    "locations": [
      {
        "description": "Market Street, Lancaster, LA1 1HT",
        "id": "60e48c6c60c142001eb6ddb3",
        "imageUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/613cb406b30734001ec79fbc/original/marketsquare.jpg",
        "latitude": 54.048825,
        "locationNotes": [],
        "longitude": -2.801197,
        "owner": "MusicFestival",
        "thumbUrl": "https://s3.eu-west-1.amazonaws.com/assets.knack-eu.com/assets/60a243fc1d20a3001b343aaa/613cb406b30734001ec79fbc/thumb/marketsquare.jpg",
        "title": "Market Square"
      }
    ],
    "hosts": [],
    "startDateUTC": "2024-10-10T00:00:00",
    "startTime": "17:30",
    "tags": [],
    "videoUrl": null,
    "participantCount": 0
  }
]
